import React, { useCallback, useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import noop from '../../../../utils/noop';
import { getCommentableTypeForDeviationType } from '../../../../DeviationPage/redux/helpers';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import Stats from '../../../../Stats';
import useFocusOnCommentBox from '../useFocusOnCommentBox';
import PriceAndSubscribeButton from '../PriceAndSubscribeButton';
import FaveControl from './FaveControl';
import ShareControl from './ShareControl';
import CommentControl from './CommentControl';
import s from './FeedCardActionBar.scss';
const FeedCardActionBar = ({ deviation, withFaveControl, withCommentControl, className, additionalActions, openCommentThread = noop })=>{
    const isMobile = useContext(MobileContext);
    const focusOnTopCommentBox = useFocusOnCommentBox(getCommentableTypeForDeviationType(deviation), deviation.deviationId, 'topmost', false);
    const openCommentThreadAndFocus = useCallback(()=>{
        openCommentThread();
        focusOnTopCommentBox();
    }, [
        openCommentThread,
        focusOnTopCommentBox
    ]);
    const { tier, needsSubscription } = useSubscriptionTier(deviation);
    const shouldRenderSubscribe = isMobile && !!tier && needsSubscription;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['actions']
    }, withFaveControl && /*#__PURE__*/ React.createElement(FaveControl, {
        className: s['action'],
        iconClassName: s['action-icon'],
        textClassName: s['action-text'],
        deviation: deviation
    }), withCommentControl && /*#__PURE__*/ React.createElement(CommentControl, {
        className: s['action'],
        iconClassName: s['action-icon'],
        textClassName: s['action-text'],
        disabledClassName: s['disabled'],
        deviation: deviation,
        onClick: openCommentThreadAndFocus
    }), /*#__PURE__*/ React.createElement(ShareControl, {
        buttonClassName: s['share-button'],
        className: s['action'],
        iconClassName: s['action-icon'],
        textClassName: s['action-text'],
        deviation: deviation
    }), shouldRenderSubscribe && /*#__PURE__*/ React.createElement(PriceAndSubscribeButton, {
        className: s['action'],
        tier: tier
    })), !isMobile && /*#__PURE__*/ React.createElement(Stats, {
        className: s['stats'],
        deviation: deviation,
        onlyNumbers: true,
        withFavouriteControl: withFaveControl,
        withCommentControl: withCommentControl,
        statClassName: s['stat'],
        withViewCount: false,
        withBadges: false,
        onCommentClick: openCommentThread
    }), additionalActions);
};
FeedCardActionBar.displayName = 'FeedCardActionBar';
export default FeedCardActionBar;

//# sourceMappingURL=FeedCardActionBar.js.map